import type { UIStringsOverride } from "../i18n-ui.ts";

/** Ukrainian (uk) UI strings. */
export const uk: UIStringsOverride = {
  actions: {
    addToCursor: "Додати до Cursor",
    addToVscode: "Додати до VS Code",
    askAI: "Запитати ШІ про цю сторінку",
    connectMcp: "Підключитися до MCP",
    copied: "Скопійовано!",
    copyClaudeCode: "Скопіювати команду Claude Code",
    copyCode: "Скопіювати код",
    copyCodex: "Скопіювати команду Codex",
    copyMarkdown: "Скопіювати як Markdown",
    copyServerUrl: "Скопіювати URL сервера",
    edit: "Редагувати на GitHub",
    export: "Експорт",
    exportEpub: "Експорт в EPUB",
    exportPdf: "Експорт у PDF",
    generating: "Генерація…",
    openIn: "Відкрити в {name}",
    openInChat: "Відкрити в чаті",
    scrollToTop: "Нагору",
  },
  ask: {
    ai: "ШІ",
    clear: "Очистити бесіду",
    close: "Закрити",
    copy: "Скопіювати бесіду",
    empty: "Поставте запитання щодо документації.",
    error: "Вибачте, щось пішло не так.",
    label: "Поставити запитання",
    placeholder: "Поставте запитання…",
    send: "Надіслати",
    tip: "Порада: чат можна відкрити й закрити за допомогою",
    title: "Запитати ШІ",
    you: "Ви",
  },
  banner: { dismiss: "Закрити оголошення" },
  changelog: {
    description: "Оновлення продукту та примітки до випусків.",
    showReleases: "Показати випуски {version}",
    title: "Журнал змін",
  },
  content: { diagramError: "Не вдалося відобразити цю діаграму." },
  feedback: {
    no: "Ні",
    question: "Чи була ця сторінка корисною?",
    thanks: "Дякуємо за ваш відгук!",
    yes: "Так",
  },
  languageSwitcher: { label: "Мова", untranslated: "Не перекладено" },
  nav: {
    back: "Назад",
    breadcrumb: "Навігаційний ланцюжок",
    closeNavigation: "Закрити навігацію",
    deprecated: "застаріле",
    featured: "Рекомендоване",
    githubRepository: "Репозиторій GitHub",
    navigation: "Навігація",
    primary: "Основне",
    sections: "Розділи",
    toggleNavigation: "Перемкнути навігацію",
    toggleTheme: "Перемкнути колірну тему",
  },
  notFound: {
    description: "Не вдалося знайти сторінку, яку ви шукаєте.",
    home: "Повернутися на головну",
    title: "Сторінку не знайдено",
  },
  page: {
    lastUpdated: "Останнє оновлення",
    next: "Далі",
    pagination: "Пагінація",
    previous: "Назад",
    skipToContent: "Перейти до вмісту",
  },
  search: {
    all: "Усі",
    allLanguages: "Усі мови",
    askAi: "Запитати ШІ",
    askAiHint: "Отримайте миттєву відповідь від ШІ",
    button: "Пошук",
    devOnly: "Пошук доступний у production-збірці.",
    error: "Щось пішло не так. Спробуйте ще раз.",
    label: "Пошук у документації",
    navigate: "навігація",
    noResults: "Нічого не знайдено.",
    open: "відкрити",
    placeholder: "Пошук у документації…",
    popular: "Популярне",
    preview: "перегляд",
    results: "Результати",
  },
  toc: { title: "На цій сторінці" },
};
